import React, { ChangeEvent } from 'react';
import AnimateHeight from 'react-animate-height';
import { UserProfileForm } from '../../Styles/UserProfile';
import { PrimaryModernButton } from '../../../../__core/Styles/Buttons/PrimaryModernButton';
import { withTranslation, WithTranslation } from 'react-i18next';
import { changeUsername } from '../../Actions/Actions';

type ChangeUsernameFormProps = {
  show: boolean;
  userId: number;
  closeForm: () => void;
  refreshUserData: () => void;
} & WithTranslation;

type FormValues = {
  name: string;
  surname: string;
  password: string;
};

type ChangeUsernameFormState = {
  passwordError: string;
  nameError: string;
  surnameError: string;
  values: FormValues;
};

class ChangeUsernameForm extends React.Component<
  ChangeUsernameFormProps,
  ChangeUsernameFormState
> {
  state = {
    passwordError: '',
    surnameError: '',
    nameError: '',
    values: {
      name: '',
      surname: '',
      password: '',
    },
  };

  onChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const {
      target: { value, name },
    } = event;

    this.setState(({ values }) => {
      const newValues = { ...values };
      newValues[name as keyof FormValues] = value;

      return { values: newValues };
    });
  };

  setNewUsername = async (): Promise<void> => {
    const { userId, closeForm, refreshUserData } = this.props;

    const {
      values: { name, surname, password },
    } = this.state;

    try {
      this.setState({
        passwordError: '',
        surnameError: '',
        nameError: '',
      });
      await changeUsername(userId, name, surname, password);
      this.setState({
        values: {
          name: '',
          surname: '',
          password: '',
        },
      });
      closeForm();
      refreshUserData();
    } catch ({ status = null }) {
      const wrongPasswordCode = 403;
      const wrongParameters = 400;
      if (status === wrongPasswordCode) {
        this.setState({ passwordError: 'Wrong password' });
      }
      if (status === wrongParameters && surname === '') {
        this.setState({ surnameError: 'Wrong surname' });
      }
      if (status === wrongParameters && name === '') {
        this.setState({ nameError: 'Wrong name' });
      }
    }
  };

  render(): React.ReactElement {
    const { show, t } = this.props;
    const { values, passwordError, nameError, surnameError } = this.state;

    return (
      <AnimateHeight duration={500} height={show ? 'auto' : 0}>
        <UserProfileForm>
          <div className="form-group">
            <input
              name="name"
              placeholder={t('Name')}
              className={`${nameError ? 'error' : ''}`}
              onChange={this.onChange}
              value={values.name}
            />
            <span className="error">{t(nameError)}</span>
          </div>
          <div className="form-group">
            <input
              name="surname"
              placeholder={t('Surname')}
              className={`${surnameError ? 'error' : ''}`}
              onChange={this.onChange}
              value={values.surname}
            />
            <span className="error">{t(surnameError)}</span>
          </div>

          <div className="form-group">
            <input
              type="password"
              name="password"
              className={`${passwordError ? 'error' : ''}`}
              placeholder={t('Password')}
              onChange={this.onChange}
              value={values.password}
            />
            <span className="error">{t(passwordError)}</span>
          </div>

          <PrimaryModernButton onClick={this.setNewUsername}>
            {t('Save')}
          </PrimaryModernButton>
        </UserProfileForm>
      </AnimateHeight>
    );
  }
}

export default withTranslation()(ChangeUsernameForm);
